//home.js 用于获取首页json数据

import req from './http.js'  //引入封装好的axios

//在这里定义了一个登陆的接口，把登陆的接口暴露出去给组件使用
export const GETDATA1 =params=>req('get','cms/article/list/?catid=61&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA2 =params=>req('get','cms/article/list/?catid=319&pageNum=1&pageSize=1'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA3 =params=>req('get','cms/article/list/?catid=62&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA4 =params=>req('get','cms/article/list/?catid=5&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
//这里使用了箭头函数，转换一下写法：
//export const GETTREEDATA=function(req){
//  return req('post','/GetTreeListForSoilByRegion',params)
//}
